module.exports = __webpack_public_path__ + "img/22.2b563c53.jpg";